import { Warehouse } from "@domain/inventory/models/Warehouse";
import { ApiClient } from "../../ApiClient";
import { WarehouseMapper } from "../mappers/WarehouseMapper";
import { WarehouseDTO } from "../dto/WarehouseDTO";
import { WarehouseConnection } from "@domain/inventory/models/WarehouseConnection";

export class WarehouseDataSource {
  constructor(private api: ApiClient) { }

  async getWarehouses(): Promise<Warehouse[]> {
    try {
      const response = await this.api.get<WarehouseDTO[]>('/warehouses');
      return response.data.map(WarehouseMapper.toModel);
    } catch (error) {
      throw new Error('Failed to fetch warehouses');
    }
  }

  async getWarehouse(id: string): Promise<Warehouse> {
    try {
      const response = await this.api.get<WarehouseDTO>(`/warehouses/${id}`);
      return WarehouseMapper.toModel(response.data);
    } catch (error) {
      throw new Error('Failed to fetch warehouse');
    }
  }

  async createWarehouse(name: string, location?: string, warehouseConnections?: Omit<WarehouseConnection, 'id'>[]): Promise<Warehouse> {
    try {
      const response = await this.api.post<WarehouseDTO>('/warehouses', {
        name,
        location,
        warehouseConnections
      });
      return WarehouseMapper.toModel(response.data);
    } catch (error) {
      throw new Error('Failed to create warehouse');
    }
  }

  async deleteWarehouse(id: string, options: { deleteConnections: boolean; deleteMutations: boolean }): Promise<void> {
    try {
      await this.api.delete(`/warehouses/${id}`, {
        data: options
      });
    } catch (error) {
      throw new Error('Failed to delete warehouse');
    }
  }
}